/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResultAp } from './ResultAp';
import {
    ResultApFromJSON,
    ResultApFromJSONTyped,
    ResultApToJSON,
} from './ResultAp';
import type { CalculationMode } from './CalculationMode';
import {
    CalculationModeFromJSON,
    CalculationModeFromJSONTyped,
    CalculationModeToJSON,
} from './CalculationMode';
import type { Electrolyzer } from './Electrolyzer';
import {
    ElectrolyzerFromJSON,
    ElectrolyzerFromJSONTyped,
    ElectrolyzerToJSON,
} from './Electrolyzer';

/**
 * A-Proof計算レスポンス
 * @export
 * @interface CalcApResult
 */
export interface CalcApResult {
    /**
     * ステータス
     * @type {string}
     * @memberof CalcApResult
     */
    status?: string;
    /**
     * メッセージ
     * @type {string}
     * @memberof CalcApResult
     */
    message?: string;
    /**
     * 
     * @type {CalculationMode}
     * @memberof CalcApResult
     */
    calculationMode?: CalculationMode;
    /**
     * 電解槽一覧
     * @type {Array<Electrolyzer>}
     * @memberof CalcApResult
     */
    electroyzerList?: Array<Electrolyzer>;
    /**
     * 
     * @type {ResultAp}
     * @memberof CalcApResult
     */
    result?: ResultAp;
}

/**
 * Check if a given object implements the CalcApResult interface.
 */
export function instanceOfCalcApResult(value: object): value is CalcApResult {
    return true;
}

export function CalcApResultFromJSON(json: any): CalcApResult {
    return CalcApResultFromJSONTyped(json, false);
}

export function CalcApResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalcApResult {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'message': json['message'] == null ? undefined : json['message'],
        'calculationMode': json['calculationMode'] == null ? undefined : CalculationModeFromJSON(json['calculationMode']),
        'electroyzerList': json['electroyzerList'] == null ? undefined : ((json['electroyzerList'] as Array<any>).map(ElectrolyzerFromJSON)),
        'result': json['result'] == null ? undefined : ResultApFromJSON(json['result']),
    };
}

export function CalcApResultToJSON(value?: CalcApResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'message': value['message'],
        'calculationMode': CalculationModeToJSON(value['calculationMode']),
        'electroyzerList': value['electroyzerList'] == null ? undefined : ((value['electroyzerList'] as Array<any>).map(ElectrolyzerToJSON)),
        'result': ResultApToJSON(value['result']),
    };
}

